import { GetNotesByAsset } from "../../../../common/components/notes/hooks/state/NoteSource";
import { useGetNotesByAssets } from "../../../../common/data/data-hooks/useGetNotesByAssets";
import { AssetType } from "../../../../common/types/AssetType";
import { DraftAssetType } from "../../../../common/types/DraftAssetType";
import { OrderAssetAvailability } from "../../../common/types/OrderAssetAvailability";
import { OrderRequestDashboardItem } from "../OrderRequestDashboardItem";

const prepareAssets = ({ orderRequest }: { orderRequest?: OrderRequestDashboardItem }): GetNotesByAsset[] => {
    const assets: GetNotesByAsset[] = [];

    if (!orderRequest) {
        return [];
    }

    if (orderRequest.cloudAssets.video.assetId) {
        assets.push(
            getNotesByAssetParamsForCloud({
                id: orderRequest.cloudAssets.video.assetId,
                availability: orderRequest.cloudAssets.video.availability
            })
        );
    }

    if (orderRequest.cloudAssets.soundtracks.length) {
        orderRequest.cloudAssets.soundtracks.forEach((soundtrack) => {
            if (soundtrack.assetId) {
                assets.push(
                    getNotesByAssetParamsForCloud({
                        id: soundtrack.assetId,
                        availability: soundtrack.availability
                    })
                );
            }
        });
    }

    if (orderRequest.cloudAssets.subtitles.length) {
        orderRequest.cloudAssets.subtitles.forEach((subtitle) => {
            if (subtitle.assetId) {
                assets.push(
                    getNotesByAssetParamsForCloud({
                        id: subtitle.assetId,
                        availability: subtitle.availability
                    })
                );
            }
        });
    }

    if (orderRequest.onPremAssets.video.assetId) {
        assets.push(
            getNotesByAssetParamsForOnPrem({
                id: orderRequest.onPremAssets.video.assetId,
                availability: orderRequest.onPremAssets.video.availability
            })
        );
    }

    if (orderRequest.onPremAssets.soundtracks.length) {
        orderRequest.onPremAssets.soundtracks.forEach((soundtrack) => {
            if (soundtrack.assetId) {
                assets.push(
                    getNotesByAssetParamsForOnPrem({
                        id: soundtrack.assetId,
                        availability: soundtrack.availability
                    })
                );
            }
        });
    }

    if (orderRequest.onPremAssets.subtitles.length) {
        orderRequest.onPremAssets.subtitles.forEach((subtitle) => {
            if (subtitle.assetId) {
                assets.push(
                    getNotesByAssetParamsForOnPrem({
                        id: subtitle.assetId,
                        availability: subtitle.availability
                    })
                );
            }
        });
    }

    return assets;
};

export const useOrderRequestAssetNotes = ({ orderRequest }: { orderRequest?: OrderRequestDashboardItem }) => {
    const assets = prepareAssets({ orderRequest });
    const { data: notes, isLoading } = useGetNotesByAssets({ assets });

    return { notes, areNotesLoading: isLoading };
};

const getNotesByAssetParamsForCloud = ({
    id,
    availability
}: {
    id: string;
    availability: OrderAssetAvailability;
}): GetNotesByAsset => ({
    id,
    assetType: availability === OrderAssetAvailability.FullMatch ? AssetType.Cloud : undefined,
    draftAssetType: availability === OrderAssetAvailability.PartialMatch ? DraftAssetType.Cloud : undefined
});

const getNotesByAssetParamsForOnPrem = ({
    id,
    availability
}: {
    id: string;
    availability: OrderAssetAvailability;
}): GetNotesByAsset => ({
    id,
    assetType: availability === OrderAssetAvailability.FullMatch ? AssetType.OnPrem : undefined,
    draftAssetType: availability === OrderAssetAvailability.PartialMatch ? DraftAssetType.OnPrem : undefined
});
